import { TENANT_IDS } from "../constants/tenantIds";

type FixedTenant = { id: string; name: string };

type WastePipelineConfig = {
  /** Display label for UI dropdown */
  label: string;
  /** Whether the pipeline accepts an optional second file */
  hasAdditionalFile: boolean;
  /** If set, pipeline is locked to this tenant (skips org picker in UI) */
  fixedTenant: FixedTenant | null;
};

export const WASTE_PIPELINE_REGISTRY = {
  "amazon-clean-harbors": {
    label: "Amazon Clean Harbors",
    hasAdditionalFile: true,
    fixedTenant: { id: TENANT_IDS.AMAZON, name: "Amazon" },
  },
  "clean-harbors": {
    label: "Clean Harbors",
    hasAdditionalFile: false,
    fixedTenant: null,
  },
} as const satisfies Record<string, WastePipelineConfig>;

export type WastePipelineName = keyof typeof WASTE_PIPELINE_REGISTRY;

export function isWastePipelineName(name: string): name is WastePipelineName {
  return name in WASTE_PIPELINE_REGISTRY;
}

export const WASTE_PIPELINE_NAMES =
  Object.keys(WASTE_PIPELINE_REGISTRY).filter(isWastePipelineName);
